import { ref } from "vue";
import { defineStore } from "pinia";

export const useModalStore = defineStore("modal", () => {
  const opened = ref(false);
  const options = ref(null);

  return { opened, options };
});
